export default "__VITE_ASSET__BKsa_tXp__"